import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable, throwError} from 'rxjs';
import {catchError} from "rxjs/operators";
import {TermsOfUseResponse} from '../models/terms-of-use-response.model';
import {DomainNameParserService} from '../../shared/services/domain-name-parser.service';

@Injectable({
  providedIn: 'root'
})
export class TermsOfUseService {

  private readonly serviceLayerHost;
  private readonly termsOfUsePath;

  constructor(private http: HttpClient, private domainNameParserService: DomainNameParserService) {
    this.serviceLayerHost = environment.serviceLayer.host[domainNameParserService.getState()];

    if(domainNameParserService.getState() == 'DG') {
      this.termsOfUsePath = '/public/v1/applications/DN/terms-of-use?state=IL'
    } else {
      this.termsOfUsePath = '/public/v1/applications/DB/terms-of-use?state=' + domainNameParserService.getState();
    }
  }

  public getTermsOfUse(): Observable<TermsOfUseResponse> {
    return this.http.get<TermsOfUseResponse>(this.getTermsOfUseUrl(), {
      headers: new HttpHeaders()
        .set('Accept', 'application/json')
    }).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Server returned error response. Details: ' + JSON.stringify(err));
        return throwError('Cannot parse response from SL server.');
      })
    );
  }

  private getTermsOfUseUrl(): string {
    // return this.serviceLayerHost + this.termsOfUsePath;
    return "termsOfUse";
  }
}
